import { useRef } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Upload, FileDown } from "lucide-react";

const SAMPLE_LINKS = [
  ["/sample-shopify-orders.csv", "Sample Shopify file", "download-sample-link"],
  ["/sample-paypal-orders.csv", "Sample PayPal file", "download-paypal-sample-link"],
  ["/sample-venmo.csv", "Sample Venmo file", "download-venmo-sample-link"],
  ["/sample-cashapp.csv", "Sample Cash App file", "download-cashapp-sample-link"],
];

export const UploadStep = ({ platform, setPlatform, busy, onFile }) => {
  const fileRef = useRef(null);

  return (
    <Card className="shadow-sm fade-in">
      <CardContent className="p-8 space-y-6">
        <div className="space-y-1.5 max-w-xs">
          <Label>Where is this file from?</Label>
          <Select value={platform} onValueChange={setPlatform}>
            <SelectTrigger data-testid="import-platform-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              {["Shopify", "PayPal", "Venmo", "Cash App", "Skool"].map((p) => (
                <SelectItem key={p} value={p}>{p}</SelectItem>
              ))}
              <SelectItem value="Other">Somewhere else</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <label
          className="flex flex-col items-center justify-center gap-3 rounded-lg border-2 border-dashed border-border bg-secondary/30 py-16 cursor-pointer hover:border-primary/50 hover:bg-secondary/50 transition-colors duration-200"
          data-testid="upload-dropzone"
        >
          <Upload className="h-8 w-8 text-primary" />
          <p className="font-medium">{busy ? "Reading your file…" : "Click to choose a CSV file"}</p>
          <p className="text-sm text-muted-foreground">Shopify, PayPal, Venmo, and Cash App exports are recognized automatically. Other layouts get a column-matching screen.</p>
          <input
            ref={fileRef} type="file" accept=".csv" className="hidden" disabled={busy}
            onChange={(e) => onFile(e.target.files[0])}
            data-testid="file-input"
          />
        </label>
        <div className="flex flex-wrap gap-x-6 gap-y-2">
          {SAMPLE_LINKS.map(([href, label, tid]) => (
            <a key={href} href={href} download className="inline-flex items-center gap-2 text-sm text-primary hover:underline" data-testid={tid}>
              <FileDown className="h-4 w-4" /> {label}
            </a>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
